import { provideEnvironmentNgxMask } from 'ngx-mask';

import { provideHttpClient, withFetch } from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  NgZone,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  RouteReuseStrategy,
  Router,
  provideRouter,
  withDisabledInitialNavigation,
  withNavigationErrorHandler,
} from '@angular/router';

import { initializeAppFactory } from './app.initializer';
// Routes
import { appRoutes } from './app.routes';
// Errors
import { AirbrakeErrorHandler } from './shared/errors';
import { FeatureFlagsService } from './shared/services';
import { AuthService } from './shared/ui/services/auth/auth.service';
import {
  NoReuseStrategy,
  PhoenixTrpcClient,
  createNavigationErrorHandler,
  createPhoenixTrpcClient,
  provideFirebaseAuth,
} from './utils';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    {
      provide: ErrorHandler,
      useClass: AirbrakeErrorHandler,
    },
    { provide: RouteReuseStrategy, useClass: NoReuseStrategy },
    provideHttpClient(withFetch()),
    provideRouter(
      appRoutes,
      withDisabledInitialNavigation(),
      withNavigationErrorHandler(createNavigationErrorHandler())
    ),
    provideFirebaseAuth(),
    provideEnvironmentNgxMask(),
    provideHttpClient(),
    provideAppInitializer(() => {
      const initializerFn = initializeAppFactory(
        inject(AuthService),
        inject(FeatureFlagsService),
        inject(Router),
        inject(NgZone)
      );
      return initializerFn();
    }),
    {
      provide: PhoenixTrpcClient,
      useFactory: createPhoenixTrpcClient,
    },
  ],
};
